import styles from './uploader.module.scss';

type TDocumentUploaderProps = {
  file: File | string | undefined;
  setFile: React.Dispatch<React.SetStateAction<File | undefined>>;
};
const DocumentUploader = ({ file, setFile }: TDocumentUploaderProps) => {
  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = e?.target;
    if (files && files[0]) {
      setFile(files?.[0]);
    }
  };

  return (
    <>
      <div className={styles['uploader']}>
        <input type="file" onChange={handleUpload} accept=".jpg, .jpeg" />
        {file instanceof File ? (
          <img
            className={styles['uploader__img']}
            src={URL.createObjectURL(file as File)}
            alt={(file as File)?.name}
          />
        ) : file ? <img
          className={styles['uploader__img']}
          src={file}
          alt={file}
        /> : (
          <div className={styles['uploader__icon']}>
            <i className="icon-gallery color-gray-3"></i>
          </div>
        )}
      </div>
    </>
  );
};

export default DocumentUploader;
